import { Injectable, ViewContainerRef, inject } from '@angular/core';
import { IgxOverlayService } from '@infragistics/igniteui-angular/core';

import { PcTabletLoadingSpinnerComponent } from '@UIparts/common/loading-spinner/pc-tablet-ver/loading-spinner.component';
import { LoadingSpinnerBaseService } from '@VineyardLib/services/loading-spinner-wrapper.service';
import {
  DISABLE_ZOOM_STYLE_CLASS,
  overlayStyleClasses,
} from '@VineyardLibConstant/constant';

@Injectable({
  providedIn: 'root',
})
export class PcTabletLoadingSpinnerService extends LoadingSpinnerBaseService {
  overlayService = inject<IgxOverlayService>(IgxOverlayService);

  private overlayId?: string;

  /**
   * スピナーの初期化
   * @param viewContainerRef:スピナーを表示するコンポーネントのViewContainerRef
   */
  public attach(viewContainerRef: ViewContainerRef): void {
    this.overlayId = this.overlayService.attach(
      PcTabletLoadingSpinnerComponent,
      viewContainerRef,
      {
        closeOnOutsideClick: false,
        closeOnEscape: false,
      }
    );
    // overlayの重なり順の制御のため、z-index制御のためのスタイルクラスをoverlayに追加する
    this.overlayService
      .getOverlayById(this.overlayId)
      .wrapperElement?.classList.add(
        overlayStyleClasses.loadingSpinner,
        DISABLE_ZOOM_STYLE_CLASS
      );
  }

  /**
   * スピナーの表示
   */
  override show(): void {
    if (this.overlayId != null) {
      this.overlayService.show(this.overlayId);
    }
  }

  /**
   * スピナーの非表示
   */
  override hide(): void {
    if (this.overlayId != null) {
      this.overlayService.hide(this.overlayId);
    }
  }
}
